import { render, staticRenderFns } from "./ReactOnComplainPopup.vue?vue&type=template&id=b97058a6"
import script from "./ReactOnComplainPopup.vue?vue&type=script&lang=js"
export * from "./ReactOnComplainPopup.vue?vue&type=script&lang=js"
import style0 from "./ReactOnComplainPopup.vue?vue&type=style&index=0&id=b97058a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports